import { render, staticRenderFns } from "./AdminUserSetting.vue?vue&type=template&id=842184ca&"
import script from "./AdminUserSetting.vue?vue&type=script&lang=ts&"
export * from "./AdminUserSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports